import React from 'react';
import {httpRequest} from "../../services/httpService";
import {Link} from 'react-router-dom';
import Table from "../../Components/Dashboard/Table";
import Loading from "../../Components/Dashboard/Loading";

const Events = () => {
    // Load all events
    const [events, setEvents] = React.useState([]);
    const [isLoading, setLoading] = React.useState(true);

    React.useEffect(() => {
        httpRequest(`${process.env.REACT_APP_API_URI}/events`)
            .then(({data}) => {
                setEvents(data);
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => setLoading(false));
    }, []);

    const columns = React.useMemo(() => [
        {
            Header: 'Title',
            accessor: 'title',
        },
        {
            Header: 'Type',
            accessor: (event => (
                <span className={`text-black-50 badge ${event.type === 'Promo' ? 'badge-primary' : 'badge-info'}`}>
                        {event.type}
                    </span>
            )),
        },
        {
            Header: 'Date',
            accessor: 'createdAt',
        },
        {
            Header: 'View',
            accessor: (event => (
                <Link to={`/events/${event.id}`}
                      className={"btn-sm btn-primary"}>
                    View
                </Link>
            )),
        },
    ], []);

    return (
        <div className="container-fluid mt--6">
            <div className="row">
                <div className="col">
                    <div className="card">
                        {
                            isLoading && (
                                <div className="text-center my-auto">
                                    <Loading/>
                                </div>
                            )
                        }
                        {
                            !isLoading && (
                                <React.Fragment>
                                    <div className="card-header border-0">
                                        <h3 className="mb-0">MAS Motors Events</h3>
                                        <small>Promotions | News</small>
                                    </div>
                                    <Table columns={columns} data={events}/>
                                </React.Fragment>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Events;